export default __webpack_public_path__ + "static/media/animation.2a772229.gif";